import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9fbe01ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emmaus-wrap py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "emmaus-intro text-center mb-5" }, " Révision, approfondissement théologique appliqué et ateliers de travail ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-box mb-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Le "),
    /*#__PURE__*/_createElementVNode("strong", null, "Parcours Disciples d’Emmaüs Sup"),
    /*#__PURE__*/_createTextVNode(" est consacré à la révision et à l’approfondissement théologique appliqué, à partir des acquis des deux premières années et par des ateliers de travail. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Le programme comporte "),
    /*#__PURE__*/_createElementVNode("strong", null, "trois axes majeurs"),
    /*#__PURE__*/_createTextVNode(" : révision, étude de thèmes et mini-mémoire. ")
  ])
], -1))
const _hoisted_5 = { class: "row g-4 mb-5" }
const _hoisted_6 = { class: "emmaus-card" }
const _hoisted_7 = { class: "emmaus-number" }
const _hoisted_8 = { class: "axis-title" }
const _hoisted_9 = { class: "axis-desc" }
const _hoisted_10 = { class: "section-box mb-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3" }, "1. Révision", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Chaque module enseigné durant les deux premières années bénéficie d’une ou deux heures de révision. ", -1))
const _hoisted_13 = { class: "list-inline" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, " Le professeur peut soit laisser une ou plusieurs personnes présenter un résumé du cours suivi de 15 mn, des questions en 15 mn ; et à la fin, il offre son résumé par rapport aux axes majeurs ; soit présenter directement son résumé suivi de questions. ", -1))
const _hoisted_15 = { class: "section-box mb-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3" }, "2. Étude de thèmes", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Sept thèmes sont étudiés en perspective pluridisciplinaire. L’enseignant se présente ici comme un véritable tuteur. ", -1))
const _hoisted_18 = { class: "timeline" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "timeline-dot" }, null, -1))
const _hoisted_20 = { class: "row g-4 mt-4" }
const _hoisted_21 = { class: "theme-card" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"section-box mb-5\" data-v-9fbe01ca><h4 class=\"section-subtitle mb-3\" data-v-9fbe01ca>3. Mini-mémoire</h4><p data-v-9fbe01ca> À la fin du parcours, le disciple dispose de <strong data-v-9fbe01ca>3 mois</strong> pour rédiger un mini-mémoire de <strong data-v-9fbe01ca>25 à 50 pages</strong>, sous la direction d’un encadreur. Le mémoire sera présenté selon des conditions bien définies. </p></div><div class=\"row g-4 mb-5\" data-v-9fbe01ca><div class=\"col-md-6\" data-v-9fbe01ca><div class=\"info-box\" data-v-9fbe01ca><h5 data-v-9fbe01ca>Organisation</h5><p data-v-9fbe01ca><strong data-v-9fbe01ca>40 à 50 séances</strong> sur l’année</p></div></div><div class=\"col-md-6\" data-v-9fbe01ca><div class=\"info-box\" data-v-9fbe01ca><h5 data-v-9fbe01ca>Coût</h5><ul data-v-9fbe01ca> Le coût de la 3 ème année s&#39;élève à 80 000 FCFA <li data-v-9fbe01ca>Inscription : <strong data-v-9fbe01ca>5 000 FCFA</strong></li><li data-v-9fbe01ca> Frais de photocopies : <strong data-v-9fbe01ca>5 000 FCFA</strong></li><li data-v-9fbe01ca> Frais de Formation : <strong data-v-9fbe01ca>70 000 FCFA</strong></li></ul></div></div></div><div class=\"section-box\" data-v-9fbe01ca><h4 class=\"section-subtitle mb-3\" data-v-9fbe01ca>Critères &amp; Attestation</h4><ul data-v-9fbe01ca><li data-v-9fbe01ca>Le cours est ouvert aux disciples</li><li data-v-9fbe01ca>L’inscription est possible pour les Habitués et Auditeurs qui le souhaitent, sur demande. </li><li data-v-9fbe01ca> Les disciples reçoivent une <strong data-v-9fbe01ca>attestation à la fin de formation-icon-wrapper</strong></li><li data-v-9fbe01ca> Les habitués et auditeurs reçoivent un <strong data-v-9fbe01ca>certificat de fin de formation</strong> (sans obligation de mémoire) </li></ul></div><br data-v-9fbe01ca><br data-v-9fbe01ca><br data-v-9fbe01ca><div class=\"text-center\" data-v-9fbe01ca><a href=\"/FicheInscriptiontroisième année.pdf\" download=\"FicheInscriptiontroisième année.pdf\" class=\"btn-download me-3\" data-v-9fbe01ca> Télécharger la fiche d&#39;inscription </a></div>", 7)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.axes, (axis, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: i
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(i + 1), 1),
              _createElementVNode("h5", _hoisted_8, _toDisplayString(axis.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(axis.description), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.revisionModules, (m, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(m), 1))
          }), 128))
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sessions, (s, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "timeline-item"
            }, [
              _hoisted_19,
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(s.title), 1),
                _createElementVNode("p", null, _toDisplayString(s.text), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.themes, (theme, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-6",
              key: i
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h6", null, _toDisplayString(i + 1) + ". " + _toDisplayString(theme.title), 1),
                (theme.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(theme.subtitle), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _hoisted_23
    ])
  ]))
}